/**
 * Feature flags do app.
 * studentQuiz: false = oculta Quiz livre para alunos; mantém Aplicar Simulado (/student/simulation/:id).
 */
export const FEATURES = {
  studentQuiz: false,
} as const;
